{
  "new": "New note",
  "searchPlaceholder": "Search notes",
  "searchClear": "Clear search",
  "searchTooShort": "Type at least two characters",
  "empty": "No notes yet",
  "nothingFound": "Nothing found",
  "loadFailed": "Could not load notes",
  "loading": "Loading notes",
  "loadingMore": "Loading more notes",
  "shared": "Shared access",
  "open": "Open note",
  "title": "Title",
  "titlePlaceholder": "Note title",
  "descriptionPlaceholder": "Add a description…",
  "save": "Save",
  "cancel": "Cancel",
  "delete": "Delete",
  "deleteConfirm": "Delete this note? Its files will be deleted too.",
  "filesDrop": "Drop files here",
  "relatedObjects": "Related objects",
  "mentionSearchHint": "Type 2 characters to search",
  "mentionSearching": "Searching…",
  "shares": "Sharing",
  "shareProject": "Project",
  "shareCompany": "Company",
  "sharePerson": "User",
  "shareRead": "Reader",
  "shareEdit": "Editor",
  "shareAdd": "Add",
  "shareSearch": "Company, project, or person",
  "shareGroupCompany": "Company",
  "shareGroupProjects": "Projects",
  "shareGroupPeople": "People",
  "shareColumnWho": "Who",
  "shareColumnAccess": "Access",
  "shareRemove": "Stop sharing",
  "shareInactive": "No longer in the company",
  "shareCompanyWith": "Everyone in “{{name}}”",
  "task": "Create task",
  "cut": "Cut into task",
  "taskTitle": "Task from note",
  "taskProject": "Project",
  "taskName": "Title",
  "taskCreate": "Create",
  "taskNeedProject": "Choose a project",
  "taskNeedTitle": "Enter a title",
  "taskNeedSelection": "Select the part you want to cut",
  "readOnly": "Read only",
  "pin": "Pin",
  "unpin": "Unpin",
  "actions": "Actions",
  "copyLink": "Copy link",
  "linkCopied": "Link copied",
  "copyFailed": "Could not copy the link",
  "backToList": "Back to list",
  "openAccess": "Open access"
}
